import { useState, useCallback } from "react";
import ModalPopup from "../components/ModalPopup";

export function useConfirmModal() {
  const [modalState, setModalState] = useState({
    isOpen: false,
    title: "",
    message: "",
    resolve: null,
  });

  const confirm = useCallback((title, message) => {
    return new Promise((resolve) => {
      setModalState({
        isOpen: true,
        title,
        message,
        resolve,
      });
    });
  }, []);

  const handleYes = () => {
    modalState.resolve(true);
    setModalState({ ...modalState, isOpen: false });
  };

  const handleNo = () => {
    modalState.resolve(false);
    setModalState({ ...modalState, isOpen: false });
  };

  const ConfirmModal = (
    <ModalPopup
      titleName={modalState.title}
      content={<div style={{ textAlign: "center" }}>{modalState.message}</div>}
      isOpen={modalState.isOpen}
      onClose={handleNo}
      onNo={handleNo}
      onYes={handleYes}
    />
  );

  return { confirm, ConfirmModal };
}
